import React from 'react';
import { LinkedinIcon, TwitterIcon, GithubIcon, MapPinIcon } from 'lucide-react';
import { MAILTO } from '../utils/mailto';
export function Footer() {
  return <footer className="w-full bg-carbon-footer text-white" data-id="element-529">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20" data-id="element-530">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 lg:gap-12" data-id="element-531">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-532">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/3zho3j7rbfxjzyaqujg3yf/f38cb422-8081-435a-bada-933114ce7768/carbonsafe-logo-favicon.svg" alt="CarbonSafe — Carbon Accounting & dMRV Platform Uganda" className="w-full max-w-[72px] h-auto brightness-0 invert" data-id="element-533" />

            <p className="mt-4 text-sm text-white/50 leading-relaxed" data-id="element-534">
              Uganda's leading independent carbon accounting and dMRV platforms.
            </p>
            <div className="mt-4 flex items-start gap-2 text-xs text-white/40" data-id="element-535">
              <MapPinIcon className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-carbon-bright/60" data-id="element-536" />
              <span data-id="element-537">Serena Heights Kigo, Kampala, Uganda</span>
            </div>
            <div className="mt-2 space-y-1" data-id="element-538">
              <a href="tel:+256776007755" className="block text-xs text-white/40 hover:text-carbon-bright transition-colors" data-id="element-539">

                +256 776 007755
              </a>
              <a href={MAILTO.footerContact} className="block text-xs text-white/40 hover:text-carbon-bright transition-colors" data-id="element-540">

                operations@carbonsafe.earth
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div data-id="element-541">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-542">
              Solutions
            </h3>
            <ul className="space-y-3" data-id="element-543">
              <li data-id="element-544">
                <a href="/ghg" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-545">

                  GHG Accounting Uganda
                </a>
              </li>
              <li data-id="element-546">
                <a href="/coffee" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-547">

                  Coffee Traceability EUDR
                </a>
              </li>
              <li data-id="element-548">
                <a href="/cookstoves" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-549">

                  Cookstove Carbon Credits
                </a>
              </li>
              <li data-id="element-550">
                <a href="/forestry" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-551">

                  Forestry & REDD+ Uganda
                </a>
              </li>
              <li data-id="element-552">
                <a href="/agroforestry" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-553">

                  Agroforestry & Soil Carbon
                </a>
              </li>
              <li data-id="element-554">
                <a href="/energy" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-555">

                  Renewable Energy Credits
                </a>
              </li>
            </ul>
          </div>

          {/* Compliance */}
          <div data-id="element-556">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-557">
              Compliance
            </h3>
            <ul className="space-y-3" data-id="element-558">
              <li data-id="element-559">
                <a href="/ifrs" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-560">

                  IFRS S1 & S2 Reporting
                </a>
              </li>
              <li data-id="element-561">
                <a href="/csrd" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-562">

                  EU CSRD Uganda
                </a>
              </li>
              <li data-id="element-563">
                <a href="/cbam" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-564">

                  CBAM Carbon Border Tax
                </a>
              </li>
              <li data-id="element-565">
                <a href="/eudr" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-566">

                  EUDR Due Diligence
                </a>
              </li>
              <li data-id="element-567">
                <a href="/ghg" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-568">

                  Uganda Climate Change Act
                </a>
              </li>
              <li data-id="element-569">
                <a href="/ghg" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-570">

                  NEMA Environmental Audit
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-571">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-572">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-573">
              <li data-id="element-574">
                <a href="/about" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-575">

                  About CarbonSafe
                </a>
              </li>
              <li data-id="element-576">
                <a href={MAILTO.footerContact} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-577">

                  Contact Us
                </a>
              </li>
              <li data-id="element-578">
                <a href={MAILTO.footerDemo} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-579">

                  Book a Demo
                </a>
              </li>
              <li data-id="element-580">
                <a href={MAILTO.footerPartners} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-581">

                  Partners
                </a>
              </li>
              <li data-id="element-582">
                <a href={MAILTO.footerCareers} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-583">

                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-584">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-585">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-586">
              <li data-id="element-587">
                <a href={MAILTO.footerPrivacy} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-588">

                  Privacy Policy
                </a>
              </li>
              <li data-id="element-589">
                <a href={MAILTO.footerTerms} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-590">

                  Terms of Service
                </a>
              </li>
              <li data-id="element-591">
                <a href={MAILTO.footerContact} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-592">

                  Cookie Policy
                </a>
              </li>
              <li data-id="element-593">
                <a href={MAILTO.footerContact} className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-594">

                  Security
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* SEO keyword block */}
        <div className="mt-14 pt-8 border-t border-white/10" data-id="element-595">
          <p className="text-xs text-white/20 leading-relaxed max-w-4xl" data-id="element-596">
            CarbonSafe provides carbon accounting software, ESG reporting, and
            digital MRV (dMRV) services in Uganda and East Africa. Our platform
            supports GHG inventory management, Scope 1 2 3 emissions tracking,
            EUDR coffee traceability, cookstove carbon credits, REDD+ forestry
            verification, agroforestry soil carbon, and renewable energy
            credits. Serving Kampala, Entebbe, Jinja, Mbarara, and across Uganda
            — helping enterprises meet IFRS S2, CSRD, CBAM, and Uganda Climate
            Change Act requirements.
          </p>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-597">
          <p className="text-sm text-white/40" data-id="element-598">
            © 2026 CarbonSafe Earth Ltd. All rights reserved. · Kampala, Uganda
          </p>
          <div className="flex items-center gap-4" data-id="element-599">
            <a href="https://linkedin.com/company/carbonsafe" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="CarbonSafe on LinkedIn" data-id="element-600">

              <LinkedinIcon className="w-5 h-5" data-id="element-601" />
            </a>
            <a href="https://twitter.com/carbonsafe" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="CarbonSafe on Twitter" data-id="element-602">

              <TwitterIcon className="w-5 h-5" data-id="element-603" />
            </a>
            <a href="https://github.com/carbonsafe" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="CarbonSafe on GitHub" data-id="element-604">

              <GithubIcon className="w-5 h-5" data-id="element-605" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}